// extracted by mini-css-extract-plugin
export var button = "asideCards-module--button--FIFll";
export var indicator = "asideCards-module--indicator--c+Znu";
export var indicatorDimmed = "asideCards-module--indicator--dimmed--+fc7b";
export var indicatorHidden = "asideCards-module--indicator--hidden--toc8d";
export var asideCards = "asideCards-module--aside-cards--2DGUz";
export var asideCards__controls = "asideCards-module--aside-cards__controls--zcRQm";
export var asideCards__inner = "asideCards-module--aside-cards__inner--mBdkI";